import { Props } from './AppCheckbox'

import styles from './AppCheckbox.module.scss'

const helper = {
  init: (props: Props) => {
    const result = [styles.checkbox]

    if (props.admin) {
      result.push(styles.admin)
    }

    if (props.notActive) {
      result.push(styles.notActive)
    }
    
    return result
  },

  checked: (props: Props) => {
    const defaultValue = null
    return (props.checked ? styles. checked : defaultValue)
  },

  disabled: (props: Props) => {
    const defaultValue = null
    return (props.disabled ? styles.disabled : defaultValue)
  },
}

export default helper